export default __webpack_public_path__ + "static/media/logo-spearline-condensed.0de86cea.svg";